
import { useState, useMemo } from 'react';
import { CountryItem } from '../types';

export const useCountriesFilters = (countries: CountryItem[]) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

  const filteredCountries = useMemo(() => {
    return countries.filter(country => {
      // Search filter
      const matchesSearch = !searchQuery || 
        country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        country.code.toLowerCase().includes(searchQuery.toLowerCase());

      // Region filter
      const matchesRegion = !selectedRegion || 
        (selectedRegion === 'no-region' && !country.region_id) ||
        (selectedRegion !== 'no-region' && country.region_id === selectedRegion);

      // Status filter
      const matchesStatus = !selectedStatus ||
        (selectedStatus === 'active' && country.active) ||
        (selectedStatus === 'inactive' && !country.active);

      return matchesSearch && matchesRegion && matchesStatus;
    });
  }, [countries, searchQuery, selectedRegion, selectedStatus]);

  return {
    filteredCountries,
    searchQuery,
    setSearchQuery,
    selectedRegion,
    setSelectedRegion,
    selectedStatus,
    setSelectedStatus
  };
};
